var userColors = [
    'bg-cognac',
    'bg-matisse',
    'bg-studio',
    'bg-tropical-rain-forest',
    'bg-cerulean.default',
];
export var randomUserColor = userColors[Math.floor(Math.random() * (userColors.length - 1))];
